export const upryzzeColorGradient = "linear-gradient(120deg, #2563eb 0%, #7c3aed 55%, #ab2ddd 100%)";
export const upryzzeTaglineColor = "#ffffff";
export const upryzzeSubtextColor = "rgba(255, 255, 255, 0.85)";

export const upryzzeHomeLayout = {
  maxWidth: 960,
  borderRadius: 4,
  px: { xs: 3, sm: 5, md: 7 },
  py: { xs: 6, sm: 8, md: 10 },
  my: { xs: 2, sm: 3, md: 4 },
};

export const upryzzeHomeContentSpacing = {
  section: 3,
  actions: 2,
  benefits: 1,
};

export const upryzzeHelpLayout = {
  maxWidth: 960,
  borderRadius: 4,
  px: { xs: 3, sm: 5, md: 7 },
  py: { xs: 6, sm: 8, md: 10 },
  my: { xs: 2, sm: 3, md: 4 },
};

export const upryzzeHelpSpacing = {
  section: 3,
  actions: 2,
  faq: 2,
};

export const supportEmail = "supportUpryzze@Upryzze.com";

export const upryzzeHeaderStyles = {
  backgroundImage: upryzzeColorGradient,
  borderBottom: "none",
  boxShadow: "0 10px 30px rgba(37, 99, 235, 0.28)",
  textColor: "#f8fafc",
  mutedTextColor: "rgba(248, 250, 252, 0.78)",
};
